import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  className?: string;
  onClick?: () => Promise<void>;
}

export const PaginationLink = ({ className, children, onClick }: IProps): ReactElement => (
  <button
    onClick={() => {
      void onClick?.();
    }}
    className={classNames('page-link', className)}
  >
    {children}
  </button>
);
